import { Navigate } from "react-router-dom";

/** Legacy route — redirige al nuevo home modular. */
export const DashboardPage = () => <Navigate to="/home" replace />;

export default DashboardPage;
